import { isEmpty } from 'lodash'
import { defaultExportMenu, getPieSeries } from '../helpers'

export default ({ config, data, color }) => {
  const { labelColor } = color
  const {
    series,
    height,
    insideLabels,
    removeLegend,
    pieRadius,
    innerRadius,
    paddingTop,
    labelFontSize,
    centerTitle,
    exportingMenu,
    disabledAnimations = false,
    ...restConfig
  } = config

  const pieseries = [
    getPieSeries({
      series,
      labelFontSize,
      otherConfig: {
        labelColor,
        centerTitle,
        insideLabels,
        innerRadius,
        color,
        disabledAnimations,
        ...restConfig
      }
    })
  ]
  const pieConf = {
    paddingTop: paddingTop,
    type: 'PieChart',
    height,
    data,
    series: pieseries,
    legend: {
      useDefaultMarker: true,
      labels: {
        marginLeft: 0,
        fill: labelColor,
        fontSize: labelFontSize,
        text: '{category}'
      },
      valueLabels: {
        template: {
          type: 'Label',
          disabled: true
        }
      },
      contentAlign: 'left',
      markers: {
        children: [
          {
            width: 20,
            height: 20,
            fontSize: 200,
            strokeWidth: 0,
            paddingTop: 2.5,
            marginLeft: 22.5,
            paddingLeft: 2.5,
            strokeOpacity: 0,
            paddingRight: 2.5,
            paddingBottom: 2.5,
            cornerRadiusTopLeft: 0,
            cornerRadiusTopRight: 0,
            cornerRadiusBottomLeft: 0,
            cornerRadiusBottomRight: 0
          }
        ]
      }
    }
  }
  if (removeLegend) {
    delete pieConf.legend
  }
  if (isEmpty(centerTitle)) {
    pieConf.radius = pieRadius
    pieConf.innerRadius = innerRadius
  }

  // Export menu
  if (exportingMenu && exportingMenu.enabled) {
    if (isEmpty(exportingMenu.config)) {
      pieConf.exporting = defaultExportMenu
    } else {
      pieConf.exporting = exportingMenu.config
    }
  }
  return pieConf
}
